"use strict";
let nextUid = 0;
function uid() {
  return ++nextUid;
}
exports.uid = uid;
//# sourceMappingURL=uid.js.map
